import React from 'react';

import { CFormSelect } from '@coreui/react';
import { SELECT_AN_OPTION_LABEL } from '../../constants/common';
import cn from 'classnames';
import './fields.css';

const SelectField = ({
  field,
  form,
  onChange,
  className,
  hasError,
  ...restProps
}) => {
  const handleChange = (e) => {
    const { value } = e.target;

    if (onChange) {
      onChange(value);
    }

    if (!form) {
      return;
    }
    console.log(restProps);
    if (
      value === SELECT_AN_OPTION_LABEL ||
      restProps?.options?.find(
        (option) => option.label === value && !option.value,
      )
    ) {
      form.setFieldValue(field.name, '');
    } else {
      form.setFieldValue(field.name, value);
    }
  };

  const handleBlur = () => {
    form.setFieldTouched(field.name, true);
  };

  return (
    <CFormSelect
      {...restProps}
      {...field}
      onChange={handleChange}
      onBlur={handleBlur}
      className={cn('select-field', className, hasError ? 'hasError' : '', {
        'select-placeholder': !field?.value,
      })}
    />
  );
};

export default React.memo(SelectField);
